import React from 'react';
import { Helmet } from "react-helmet";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Neralen - Ζαχαροπλαστική Τέχνη</title>
        <meta name="description" content="Neralen - Ανακαλύψτε τον κόσμο της ζαχαροπλαστικής τέχνης με αυθεντικές συνταγές και επαγγελματικές συμβουλές" />
      </Helmet>

      <div className="policy-container">
      <div className="policy-content">
        <h1>Όροι και Προϋποθέσεις Χρήσης</h1>
        <p className="last-updated">Τελευταία ενημέρωση: {new Date().toLocaleDateString('el-GR')}</p>

        <section>
          <h2>1. Αποδοχή των Όρων</h2>
          <p>
            Καλώς ήρθατε στο Neralen. Αυτοί οι Όροι και Προϋποθέσεις ("Όροι", "Όροι και Προϋποθέσεις") 
            διέπουν τη χρήση του ιστότοπού μας και των υπηρεσιών μας. Η πρόσβαση και η χρήση του ιστότοπου 
            βασίζεται στην αποδοχή και συμμόρφωσή σας με αυτούς τους Όρους. Αυτοί οι Όροι ισχύουν για 
            όλους τους επισκέπτες, χρήστες και άλλους που έχουν πρόσβαση ή χρησιμοποιούν τον ιστότοπο.
          </p>
          <p>
            Με την πρόσβαση ή τη χρήση του ιστότοπου, συμφωνείτε να δεσμεύεστε από αυτούς τους Όρους. 
            Εάν διαφωνείτε με οποιοδήποτε μέρος των όρων, τότε δεν έχετε άδεια πρόσβασης στον ιστότοπο.
          </p>
        </section>

        <section>
          <h2>2. Χρήση του Ιστότοπου</h2>
          <h3>2.1 Επιτρεπόμενη Χρήση</h3>
          <p>Συμφωνείτε να χρησιμοποιείτε τον ιστότοπο μόνο για νόμιμους σκοπούς και με τρόπο που δεν παραβιάζει τα δικαιώματα ή περιορίζει ή εμποδίζει τη χρήση και απόλαυση του ιστότοπου από οποιονδήποτε τρίτο.</p>
          
          <h3>2.2 Απαγορευμένες Δραστηριότητες</h3>
          <p>Δεν επιτρέπεται να:</p>
          <ul>
            <li>Χρησιμοποιείτε τον ιστότοπο με παράνομο τρόπο ή για την προώθηση παράνομων δραστηριοτήτων</li>
            <li>Προσπαθείτε να αποκτήσετε μη εξουσιοδοτημένη πρόσβαση στον ιστότοπο ή σε συστήματα δικτύων</li>
            <li>Μεταδίδετε ιούς, κακόβουλο λογισμικό ή άλλο επιβλαβές υλικό</li>
            <li>Συλλέγετε ή συγκεντρώνετε πληροφορίες από τον ιστότοπο χωρίς άδεια</li>
            <li>Χρησιμοποιείτε αυτοματοποιημένα συστήματα για πρόσβαση στον ιστότοπο χωρίς άδεια</li>
            <li>Παρενοχλείτε, κακοποιείτε ή βλάπτετε άλλους χρήστες</li>
            <li>Παραβιάζετε δικαιώματα πνευματικής ιδιοκτησίας</li>
          </ul>
        </section>

        <section>
          <h2>3. Λογαριασμοί Χρηστών</h2>
          <h3>3.1 Δημιουργία Λογαριασμού</h3>
          <p>
            Για πρόσβαση σε ορισμένες λειτουργίες του ιστότοπου, μπορεί να χρειαστεί να δημιουργήσετε 
            λογαριασμό. Είστε υπεύθυνοι για τη διατήρηση της εμπιστευτικότητας του λογαριασμού και του 
            κωδικού πρόσβασής σας και για τον περιορισμό της πρόσβασης στον υπολογιστή σας.
          </p>
          
          <h3>3.2 Ευθύνη Λογαριασμού</h3>
          <p>
            Συμφωνείτε να αναλάβετε την ευθύνη για όλες τις δραστηριότητες που συμβαίνουν στον λογαριασμό 
            σας ή τον κωδικό πρόσβασής σας. Πρέπει να μας ειδοποιήσετε αμέσως για οποιαδήποτε παραβίαση 
            ασφαλείας ή μη εξουσιοδοτημένη χρήση του λογαριασμού σας.
          </p>
          
          <h3>3.3 Ακύρωση Λογαριασμού</h3>
          <p>
            Διατηρούμε το δικαίωμα να διακόψουμε ή να καταργήσουμε τον λογαριασμό σας και να αρνηθούμε 
            οποιαδήποτε τρέχουσα ή μελλοντική χρήση του ιστότοπου για οποιονδήποτε λόγο, ανά πάσα στιγμή.
          </p>
        </section>

        <section>
          <h2>4. Περιεχόμενο</h2>
          <h3>4.1 Δικό μας Περιεχόμενο</h3>
          <p>
            Το περιεχόμενο του ιστότοπου, συμπεριλαμβανομένων, χωρίς περιορισμό, κειμένου, γραφικών, 
            εικόνων, λογότυπων, εικονιδίων, φωτογραφιών, κλιπ ήχου, βίντεο, συνταγών και λογισμικού, 
            ανήκει στο Neralen και προστατεύεται από νόμους περί πνευματικής ιδιοκτησίας.
          </p>
          
          <h3>4.2 Περιεχόμενο Χρήστη</h3>
          <p>
            Ο ιστότοπός μας μπορεί να σας επιτρέπει να δημοσιεύετε, να συνδέετε, να αποθηκεύετε, να 
            μοιράζεστε και να διαθέτετε με άλλο τρόπο πληροφορίες, κείμενο, γραφικά ή άλλο υλικό 
            ("Περιεχόμενο Χρήστη"). Είστε υπεύθυνοι για το Περιεχόμενο Χρήστη που δημοσιεύετε.
          </p>
          
          <h3>4.3 Άδεια Περιεχομένου Χρήστη</h3>
          <p>
            Διατηρείτε όλα τα δικαιώματα στο Περιεχόμενο Χρήστη που δημοσιεύετε. Ωστόσο, με τη δημοσίευση 
            Περιεχομένου Χρήστη, μας παρέχετε μια παγκόσμια, μη αποκλειστική, ελεύθερη δικαιωμάτων άδεια 
            χρήσης, αναπαραγωγής, τροποποίησης, προσαρμογής, δημοσίευσης και εμφάνισης αυτού του Περιεχομένου.
          </p>
        </section>

        <section>
          <h2>5. Πνευματική Ιδιοκτησία</h2>
          <p>
            Όλα τα δικαιώματα πνευματικής ιδιοκτησίας στον ιστότοπο και το περιεχόμενό του ανήκουν στο 
            Neralen ή στους χορηγούς αδειών μας. Αυτά τα δικαιώματα προστατεύονται από διεθνείς νόμους 
            πνευματικής ιδιοκτησίας.
          </p>
          <p>
            Μπορεί να εμφανίζετε, να κατεβάζετε και να εκτυπώνετε σελίδες από τον ιστότοπο για προσωπική, 
            μη εμπορική χρήση, υπό την προϋπόθεση ότι δεν τροποποιείτε το υλικό και ότι διατηρείτε όλες 
            τις σημειώσεις πνευματικών δικαιωμάτων και άλλων δικαιωμάτων ιδιοκτησίας.
          </p>
        </section>

        <section>
          <h2>6. Συνταγές και Διατροφικές Πληροφορίες</h2>
          <p>
            Οι συνταγές και οι διατροφικές πληροφορίες που παρέχονται στον ιστότοπο προορίζονται μόνο 
            για ενημερωτικούς σκοπούς. Ενώ προσπαθούμε να παρέχουμε ακριβείς πληροφορίες, δεν εγγυόμαστε 
            την ακρίβεια ή την πληρότητα αυτών των πληροφοριών.
          </p>
          <p>
            Η χρήση των συνταγών και των πληροφοριών γίνεται με δική σας ευθύνη. Δεν είμαστε υπεύθυνοι 
            για τυχόν αλλεργικές αντιδράσεις, διατροφικά ζητήματα ή άλλα προβλήματα υγείας που μπορεί 
            να προκύψουν από τη χρήση των συνταγών μας.
          </p>
        </section>

        <section>
          <h2>7. Αγορές και Πληρωμές</h2>
          <h3>7.1 Τιμές</h3>
          <p>
            Όλες οι τιμές εμφανίζονται σε Ευρώ (€) και περιλαμβάνουν ΦΠΑ, εκτός εάν αναφέρεται διαφορετικά. 
            Διατηρούμε το δικαίωμα να αλλάξουμε τις τιμές ανά πάσα στιγμή χωρίς προηγούμενη ειδοποίηση.
          </p>
          
          <h3>7.2 Μέθοδοι Πληρωμής</h3>
          <p>
            Αποδεχόμαστε διάφορες μεθόδους πληρωμής, συμπεριλαμβανομένων πιστωτικών καρτών, χρεωστικών 
            καρτών και άλλων ηλεκτρονικών μεθόδων πληρωμής. Οι πληρωμές υποβάλλονται σε επεξεργασία μέσω 
            ασφαλών παρόχων πληρωμών τρίτων.
          </p>
          
          <h3>7.3 Επιβεβαίωση Παραγγελίας</h3>
          <p>
            Αφού υποβάλετε μια παραγγελία, θα λάβετε ένα email επιβεβαίωσης. Αυτό το email επιβεβαιώνει 
            ότι έχουμε λάβει την παραγγελία σας, αλλά δεν σημαίνει ότι η παραγγελία έχει γίνει αποδεκτή. 
            Όλες οι παραγγελίες υπόκεινται στη διαθεσιμότητα και επιβεβαίωση.
          </p>
        </section>

        <section>
          <h2>8. Παράδοση</h2>
          <p>
            Καταβάλλουμε κάθε δυνατή προσπάθεια να παραδώσουμε τα προϊόντα εντός του χρονικού πλαισίου 
            που αναφέρεται κατά τη διαδικασία παραγγελίας. Ωστόσο, δεν μπορούμε να εγγυηθούμε χρόνους 
            παράδοσης και δεν φέρουμε ευθύνη για καθυστερήσεις που οφείλονται σε περιστάσεις εκτός του 
            ελέγχου μας.
          </p>
          <p>
            Ο κίνδυνος απώλειας και τίτλος για τα προϊόντα μεταβιβάζονται σε εσάς κατά την παράδοση στον 
            μεταφορέα. Είστε υπεύθυνοι να παρέχετε ακριβή διεύθυνση παράδοσης.
          </p>
        </section>

        <section>
          <h2>9. Επιστροφές και Επιστροφές Χρημάτων</h2>
          <p>
            Ανατρέξτε στην Πολιτική Επιστροφών μας για λεπτομερείς πληροφορίες σχετικά με επιστροφές, 
            ανταλλαγές και επιστροφές χρημάτων. Έχετε το δικαίωμα να ακυρώσετε την παραγγελία σας εντός 
            14 ημερών από την παραλαβή, σύμφωνα με το νόμο προστασίας καταναλωτή.
          </p>
        </section>

        <section>
          <h2>10. Αποποίηση Ευθύνης</h2>
          <p>
            Ο ιστότοπος και όλες οι πληροφορίες, το περιεχόμενο, τα υλικά, τα προϊόντα και οι υπηρεσίες 
            που περιλαμβάνονται ή είναι διαθέσιμες μέσω του ιστότοπου παρέχονται "ως έχουν" και "όπως 
            είναι διαθέσιμα", εκτός εάν ορίζεται διαφορετικά γραπτώς.
          </p>
          <p>
            Δεν προβαίνουμε σε καμία εκπροσώπηση ή εγγύηση οποιουδήποτε είδους, ρητή ή σιωπηρή, σχετικά 
            με τη λειτουργία του ιστότοπου ή τις πληροφορίες, το περιεχόμενο, τα υλικά, τα προϊόντα ή 
            τις υπηρεσίες που περιλαμβάνονται ή είναι διαθέσιμες μέσω του ιστότοπου.
          </p>
        </section>

        <section>
          <h2>11. Περιορισμός Ευθύνης</h2>
          <p>
            Σε καμία περίπτωση το Neralen, οι διευθυντές, οι υπάλληλοι, οι συνεργάτες ή οι αντιπρόσωποί 
            μας δεν θα είναι υπεύθυνοι για οποιεσδήποτε άμεσες, έμμεσες, τυχαίες, ειδικές, αποθετικές ή 
            παραδειγματικές ζημίες που προκύπτουν από τη χρήση του ιστότοπου.
          </p>
          <p>
            Ορισμένες δικαιοδοσίες δεν επιτρέπουν τον αποκλεισμό ορισμένων εγγυήσεων ή τον περιορισμό ή 
            τον αποκλεισμό ευθύνης για τυχαίες ή αποθετικές ζημίες. Κατά συνέπεια, ορισμένοι από τους 
            παραπάνω περιορισμούς μπορεί να μην ισχύουν για εσάς.
          </p>
        </section>

        <section>
          <h2>12. Αποζημίωση</h2>
          <p>
            Συμφωνείτε να υπερασπίζεστε, να αποζημιώνετε και να κρατάτε αβλαβές το Neralen και τους 
            συνεργάτες, διευθυντές, υπαλλήλους και αντιπροσώπους του από και έναντι οποιωνδήποτε 
            αξιώσεων, ζημιών, υποχρεώσεων, απωλειών, ευθυνών, κόστους ή χρέους και δαπανών που 
            προκύπτουν από:
          </p>
          <ul>
            <li>Τη χρήση και πρόσβασή σας στον ιστότοπο</li>
            <li>Την παραβίαση αυτών των Όρων</li>
            <li>Την παραβίαση δικαιωμάτων τρίτων</li>
            <li>Οποιοδήποτε Περιεχόμενο Χρήστη δημοσιεύσατε</li>
          </ul>
        </section>

        <section>
          <h2>13. Εφαρμοστέο Δίκαιο</h2>
          <p>
            Αυτοί οι Όροι διέπονται και ερμηνεύονται σύμφωνα με τους νόμους της Ελλάδας, χωρίς να λαμβάνονται 
            υπόψη οι διατάξεις περί σύγκρουσης νόμων. Η αδυναμία μας να επιβάλουμε οποιοδήποτε δικαίωμα ή 
            διάταξη αυτών των Όρων δεν θα θεωρηθεί παραίτηση από αυτά τα δικαιώματα.
          </p>
        </section>

        <section>
          <h2>14. Επίλυση Διαφορών</h2>
          <p>
            Εάν έχετε οποιαδήποτε ανησυχία ή διαφορά σχετικά με την Υπηρεσία, συμφωνείτε πρώτα να 
            προσπαθήσετε να επιλύσετε τη διαφορά ανεπίσημα επικοινωνώντας μαζί μας. Εάν μια διαφορά 
            δεν επιλυθεί εντός 30 ημερών από την υποβολή, οποιαδήποτε διαφορά που προκύπτει από αυτούς 
            τους όρους θα υποβληθεί στα αρμόδια δικαστήρια της Αθήνας, Ελλάδα.
          </p>
        </section>

        <section>
          <h2>15. Διαχωρισιμότητα</h2>
          <p>
            Εάν οποιαδήποτε διάταξη αυτών των Όρων κριθεί άκυρη ή μη εκτελεστή από δικαστήριο, οι 
            υπόλοιπες διατάξεις αυτών των Όρων θα παραμείνουν σε ισχύ. Η αδυναμία μας να ασκήσουμε ή 
            να επιβάλουμε οποιοδήποτε δικαίωμα ή διάταξη αυτών των Όρων δεν θα αποτελεί παραίτηση από 
            αυτό το δικαίωμα ή τη διάταξη.
          </p>
        </section>

        <section>
          <h2>16. Ολόκληρη Συμφωνία</h2>
          <p>
            Αυτοί οι Όροι, μαζί με την Πολιτική Απορρήτου και την Πολιτική Επιστροφών, αποτελούν την 
            πλήρη συμφωνία μεταξύ εσάς και του Neralen σχετικά με τη χρήση του ιστότοπου και αντικαθιστούν 
            όλες τις προηγούμενες και σύγχρονες συμφωνίες και επικοινωνίες.
          </p>
        </section>

        <section>
          <h2>17. Τροποποιήσεις των Όρων</h2>
          <p>
            Διατηρούμε το δικαίωμα, κατά τη διακριτική μας ευχέρεια, να τροποποιήσουμε ή να αντικαταστήσουμε 
            αυτούς τους Όρους ανά πάσα στιγμή. Εάν μια αναθεώρηση είναι ουσιαστική, θα προσπαθήσουμε να 
            παράσχουμε ειδοποίηση τουλάχιστον 30 ημερών πριν τεθούν σε ισχύ οι νέοι όροι. Το τι αποτελεί 
            ουσιαστική αλλαγή θα καθοριστεί κατά τη διακριτική μας ευχέρεια.
          </p>
        </section>

        <section>
          <h2>18. Επικοινωνία</h2>
          <p>
            Εάν έχετε οποιεσδήποτε ερωτήσεις σχετικά με αυτούς τους Όρους, μπορείτε να επικοινωνήσετε μαζί μας:
          </p>
          <ul>
            <li>Μέσω email: <a href="mailto:neralen@hotmail.com">neralen@hotmail.com</a></li>
            <li>Μέσω της φόρμας επικοινωνίας στον ιστότοπό μας</li>
            <li>Τηλεφωνικά: +30 XXX XXXXXXX</li>
            <li>Ταχυδρομικά: Neralen, Αθήνα, Ελλάδα</li>
          </ul>
        </section>
      </div>
    </div>
  
    </>);
};

export default TermsConditions;